import React from 'react'
import styles from './NextActionOverlay.module.css'

type NextActionOverlayProps = {
    /** 入力完了後かつ前進方向のステップ遷移時にtrue（EntryFormが制御） */
    isVisible: boolean
    /** オーバーレイ（ボタン外）タップ時に呼ばれるコールバック */
    onDismiss: () => void
}

export const NextActionOverlay = ({ isVisible, onDismiss }: NextActionOverlayProps) => {
    if (!isVisible) return null

    return (
        <div
            className={styles.overlay}
            onClick={onDismiss}
            aria-hidden="true"
        />
    )
}
